export type GetAuthorizationsApiResponse =
  /** status 200 Standard response */
  | ({
      id?: string | null;
      name?: string | null;
      code?: string | null;
      isActive?: boolean | null;
      vehicleMakes?: (string | null)[];
      vehicleModels?: (string | null)[];
      vehicleTypes?: (string | null)[];
      nationalSalesCompanyCountry?: string | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetAuthorizationsApiArg = {
  /** UUID */
  'x-tenant': string;
  params?: {
    code?: string;
    nationalSalesCompanyCountry?: string;
    vehicleType?: string;
    vehicleMake?: string;
    vehicleModelFamilyGroup?: string;
    vehicleModelFamily?: string;
  };
};
